import React, { Component } from "react";
import { Link } from "react-router-dom";
import Api from "../Api";
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import Autocomplete from "react-autocomplete";
import ReactPaginate from "react-paginate";
import $ from "jquery";
UIkit.use(Icons);

export default class InspectionSchedule extends Component {
  state = {
    consultName: "",
    consultId: "",
    campaignId: "",
    campaignList: [],
    consultList: [],
    list: [],
    loadingApi: false,
    pageNow: 1,
    pageAmount: 1,
    perPage: 10,
    timeStartHour: "00",
    timeStartMinute: "00",
    timeStopHour: "00",
    timeStopMinute: "00",
    weekDay: "1",
    appointment_type: "offline",
    week1: 1,
    week2: 1,
    week3: 1,
    week4: 1,
    week5: 1,
    last_update: +new Date(),
  };

  filter = {
    keyword: "",
    appointment_type: "all",
  };

  campaignById = {};

  consultById = {};

  weekNumbers = [1, 2, 3, 4, 5];

  componentDidMount() {
    this.campaignListGet();

    this.consultListGet();

    this.consultInspectionListGet();
  }
  campaignListGet = async () => {
    var _response = await Api.consult("CampaignList", { campaignId: "all" });

    this.setState({
      campaignList: _response.list || [],
      campaignId: _response.list[0] ? _response.list[0].id : "",
    });
  };

  consultListGet = async () => {
    var _response = await Api.consult("ConsultInCompany");
    this.setState({
      consultList: _response.list || [],
    });
  };

  consultInspectionAdd = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (!this.state.consultId) {
      UIkit.notification({
        message: "โปรดเลือกแพทย์",
        status: "danger",
      });

      return;
    }

    var _row = [];

    _row.push({
      weekday: this.state.weekDay,
      timestart: `${this.state.timeStartHour}:${this.state.timeStartMinute}:00`,
      timestop: `${this.state.timeStopHour}:${this.state.timeStopMinute}:00`,
      consultid: this.state.consultId,
      campaignid: this.state.campaignId,
      appointment_type: this.state.appointment_type,
    });

    this.consultInspectionSave(_row);
  };

  consultInspectionSave = async (row) => {
    var _response = await Api.consult("M2ConsultInspectionAdd", {
      row,
    });

    UIkit.notification({
      message: _response.responseText,
      status: _response.result === true ? "success" : "danger",
    });

    if (_response.result === true) {
      this.consultInspectionListGet();
    }
  };

  consultInspectionListGet = async () => {
    var _response = await Api.consult("M2ConsultInspectionList", {
      page: this.state.pageNow,
    });

    this.campaignById = _response.campaignById || {};

    this.consultById = _response.consultById || {};

    this.setState({
      list: _response.list || [],
      pageAmount: Math.ceil(
        parseInt(_response.amount || 1) / this.state.perPage,
      ),
    });
  };

  consultInspectionRemove = async (id) => {
    if (window.confirm("Confirm remove ?")) {
      var _response = await Api.consult("M2ConsultInspectionRemove", { id });

      UIkit.notification({
        message: _response.responseText,
        status: _response.result === true ? "success" : "danger",
      });

      if (_response.result === true) {
        this.consultInspectionListGet();
      }
    }
  };

  campaignSelectRender = () => {
    var _op = [
      // {label: 'All', value: 'all'},
    ];

    for (var campaign of this.state.campaignList) {
      _op.push({
        label: campaign.name + ` (UID : ${campaign.id})`,
        value: campaign.id,
      });
    }

    return (
      <select
        className="uk-select"
        value={this.state.campaignId}
        onChange={(e) => {
          this.setState({ campaignId: e.target.value });
        }}
      >
        {_op.map(function (o) {
          return (
            <option key={`campaign${o.value}`} value={o.value}>
              {o.label}
            </option>
          );
        })}
      </select>
    );
  };

  appointmentTypeSelectRender = () => {
    var _op = [
      { label: "Online", value: "online" },
      { label: "Offline", value: "offline" },
    ];

    return (
      <select
        className="uk-select"
        value={this.state.appointment_type}
        onChange={(e) => {
          this.setState({ appointment_type: e.target.value });
        }}
      >
        {_op.map(function (o) {
          return (
            <option key={`campaign${o.value}`} value={o.value}>
              {o.label}
            </option>
          );
        })}
      </select>
    );
  };

  appointmentTypeFilterSelectRender = () => {
    var _op = [
      { label: "All", value: "all" },
      { label: "Online", value: "online" },
      { label: "Offline", value: "offline" },
    ];

    return (
      <select
        className="uk-select"
        value={this.filter.appointment_type}
        onChange={(e) => {
          this.filter.appointment_type = e.target.value;
        }}
      >
        {_op.map(function (o) {
          return (
            <option key={`campaign${o.value}`} value={o.value}>
              {o.label}
            </option>
          );
        })}
      </select>
    );
  };

  weekday = {
    1: "วันจันทร์",
    2: "วันอังคาร",
    3: "วันพุธ",
    4: "วันพฤหัส",
    5: "วันศุกร์",
    6: "วันเสาร์",
    7: "วันอาทิตย์",
  };

  daySelectRender = () => {
    var _op = [];

    for (var key in this.weekday) {
      _op.push({
        label: this.weekday[key],
        value: key,
      });
    }

    return (
      <select
        className="uk-select"
        value={this.state.weekDay}
        onChange={(e) => {
          this.setState({ weekDay: e.target.value });
        }}
      >
        {_op.map(function (o) {
          return (
            <option key={`day${o.value}`} value={o.value}>
              {o.label}
            </option>
          );
        })}
      </select>
    );
  };

  timeSelectRender = (type, time, callback) => {
    var _hour = [];
    var _minute = [];

    if (!time) {
      time = "00:00";
    }

    var _data = time.split(":");

    for (var h = 0; h < 24; h++) {
      var h_use = h < 10 ? "0" + h : h;

      _hour.push(
        <option key={`hour${h_use}`} value={h_use}>
          {h_use}
        </option>,
      );
    }

    ["00", "15", "30", "45"].forEach(function (m) {
      _minute.push(
        <option key={`minute${m}`} value={m}>
          {m}
        </option>,
      );
    });

    return (
      <div className="uk-flex uk-flex-middle">
        <select
          className="uk-select"
          defaultValue={_data[0]}
          onChange={(e) => {
            _data[0] = e.target.value;
            if (type === "start") {
              this.setState({ timeStartHour: e.target.value });
            } else if (type === "stop") {
              this.setState({ timeStopHour: e.target.value });
            }

            if (typeof callback === "function") {
              callback(_data);
            }
          }}
        >
          {_hour}
        </select>{" "}
        :
        <select
          className="uk-select"
          defaultValue={_data[1]}
          onChange={(e) => {
            _data[1] = e.target.value;
            if (type === "start") {
              this.setState({ timeStartMinute: e.target.value });
            } else if (type === "stop") {
              this.setState({ timeStopMinute: e.target.value });
            }

            if (typeof callback === "function") {
              callback(_data);
            }
          }}
        >
          {_minute}
        </select>{" "}
      </div>
    );
  };

  tableTimeFormar = (d) => {
    var _d = d.split(":");

    return `${_d[0]}:${_d[1]}`;
  };

  consultInspectionUpdate = async (data) => {
    var _r = await Api.consult("M2ConsultInspectionUpdate", data);

    UIkit.notification({
      message: _r.responseText,
      status: "success",
    });
  };

  handleRowFieldChange = (list, field, value) => {
    list[field] = value;
    this.setState({ last_update: +new Date() });
  };

  handleRowTimeChange = (list, field, hours, minutes) => {
    list[field] = `${hours}:${minutes}`;
    this.setState({ last_update: +new Date() });
  };

  normalizeWeekValue = (value) => {
    return value == 1 ? 1 : 0;
  };

  getWeekStateSuffix = (list) => {
    if (!list || !list.id) {
      return "";
    }

    return `_${list.id}`;
  };

  buildWeekStateForList = (list) => {
    var suffix = this.getWeekStateSuffix(list);

    return this.weekNumbers.reduce((weekState, week) => {
      weekState[`week${week}${suffix}`] = this.normalizeWeekValue(
        list[`week${week}`],
      );

      return weekState;
    }, {});
  };

  getWeekSubmissionPayload = (list) => {
    var suffix = this.getWeekStateSuffix(list);

    return this.weekNumbers.reduce((weekPayload, week) => {
      var stateKey = `week${week}${suffix}`;
      var weekKey = `week${week}`;
      var stateValue = this.state[stateKey];

      weekPayload[weekKey] =
        stateValue !== undefined
          ? this.normalizeWeekValue(stateValue)
          : this.normalizeWeekValue(list[weekKey]);

      return weekPayload;
    }, {});
  };

  getTimeParts = (value) => {
    var _data = (value || "00:00").split(":");
    var _hour = _data[0] ? _data[0] : "00";
    var _minute = _data[1] ? _data[1] : "00";
    return {
      hours: String(_hour).padStart(2, "0"),
      minutes: String(_minute).padStart(2, "0"),
    };
  };

  renderRowTimeEditor = (list, field) => {
    var { hours, minutes } = this.getTimeParts(list[field]);

    var _hourOptions = [];
    for (var h = 0; h < 24; h++) {
      var h_use = h < 10 ? "0" + h : "" + h;
      _hourOptions.push(
        <option key={`hour-${field}-${h_use}`} value={h_use}>
          {h_use}
        </option>,
      );
    }

    var _minuteOptions = ["00", "15", "30", "45"].map((m) => (
      <option key={`minute-${field}-${m}`} value={m}>
        {m}
      </option>
    ));

    return (
      <div className="uk-flex uk-flex-middle">
        <select
          className="uk-select"
          value={hours}
          onChange={(e) => {
            this.handleRowTimeChange(list, field, e.target.value, minutes);
          }}
        >
          {_hourOptions}
        </select>
        <span className="uk-margin-small-left uk-margin-small-right">:</span>
        <select
          className="uk-select"
          value={minutes}
          onChange={(e) => {
            this.handleRowTimeChange(list, field, hours, e.target.value);
          }}
        >
          {_minuteOptions}
        </select>
      </div>
    );
  };

  finishEditingRow = async (list) => {
    list.is_editing = false;
    this.setState({ last_update: +new Date() });

    var weekPayload = this.getWeekSubmissionPayload(list);

    await this.consultInspectionUpdate({
      id: list.id,
      weekday: list.weekday,
      timestart: list.timestart,
      timestop: list.timestop,
      appointment_type: list.appointment_type,
      consultid: list.consultid,
      campaignid: list.campaignid,
      ...weekPayload,
    });
  };

  renderListRow = (list, index) => {
    return (
      <tr key={`row${index}`}>
        <td>{index + 1}</td>
        <td>
          {this.campaignById[list.campaignid]
            ? this.campaignById[list.campaignid]
            : list.campaignid}{" "}
          (UID : {list.campaignid})
        </td>
        <td>
          {this.consultById[list.consultid]
            ? this.consultById[list.consultid]
            : list.consultid}{" "}
          (UID: {list.consultid})
        </td>
        <td>
          {this.weekday[list.weekday]}
          {this.weekSelectRender({
            read_only: true,
            list,
          })}
        </td>
        <td>{this.tableTimeFormar(list.timestart)}</td>
        <td>{this.tableTimeFormar(list.timestop)}</td>
        <td>{list.appointment_type}</td>
        <td>
          <a
            onClick={() => {
              list.is_editing = true;

              this.setState({
                last_update: +new Date(),
                ...this.buildWeekStateForList(list),
              });
            }}
          >
            <span uk-icon="pencil"></span>
          </a>
        </td>
      </tr>
    );
  };

  renderEditingRow = (list, index) => {
    console.log(list);
    return (
      <tr key={`row${index}`}>
        <td>{index + 1}</td>
        <td>
          {this.campaignById[list.campaignid]
            ? this.campaignById[list.campaignid]
            : list.campaignid}{" "}
          (UID : {list.campaignid})
        </td>
        <td>
          {this.consultById[list.consultid]
            ? this.consultById[list.consultid]
            : list.consultid}{" "}
          (UID: {list.consultid})
        </td>
        <td>
          <select
            className="uk-select"
            value={`${list.weekday || "1"}`}
            onChange={(e) => {
              this.handleRowFieldChange(list, "weekday", e.target.value);
            }}
          >
            {Object.keys(this.weekday).map((key) => (
              <option key={`weekday-${key}`} value={key}>
                {this.weekday[key]}
              </option>
            ))}
          </select>

          {this.weekSelectRender({
            id: list.id,
          })}
        </td>
        <td>{this.renderRowTimeEditor(list, "timestart")}</td>
        <td>{this.renderRowTimeEditor(list, "timestop")}</td>
        <td>
          <select
            className="uk-select"
            value={list.appointment_type || "offline"}
            onChange={(e) => {
              this.handleRowFieldChange(
                list,
                "appointment_type",
                e.target.value,
              );
            }}
          >
            <option value="online">Online</option>
            <option value="offline">Offline</option>
          </select>
        </td>
        <td>
          <a
            onClick={() => {
              this.finishEditingRow(list);
            }}
          >
            <span uk-icon="check"></span>
          </a>
          <a
            className="uk-margin-left"
            onClick={() => {
              this.consultInspectionRemove(list.id);
            }}
          >
            <span uk-icon="trash"></span>
          </a>
          <a
            className="uk-margin-left"
            onClick={() => {
              list.is_editing = false;
              this.setState({ last_update: +new Date() });
            }}
          >
            ยกเลิก
          </a>
        </td>
      </tr>
    );
  };

  tableRender = () => {
    return (
      <table className="uk-table uk-table-small uk-table-striped uk-table-divider">
        <thead>
          <tr>
            <th>ลำดับ</th>
            <th>แคมเปญ</th>
            <th>แพทย์</th>
            <th>วัน</th>
            <th>เวลาเริ่ม</th>
            <th>เวลาสิ้นสุด</th>
            <th>ประเภท</th>
            <th>ลบ</th>
          </tr>
        </thead>
        <tbody>
          {this.state.list.length === 0 ? (
            <tr>
              <td colSpan={8}>
                <div className="uk-padding-small uk-text-center">
                  ไม่พบรายการ
                </div>
              </td>
            </tr>
          ) : (
            this.state.list.map((list, index) => {
              return list.is_editing === true
                ? this.renderEditingRow(list, index)
                : this.renderListRow(list, index);
            })
          )}
        </tbody>
      </table>
    );
  };

  csvJSON(text, quoteChar = '"', delimiter = ",") {
    var rows = text.split("\n");
    var headers = rows[0].split(",");

    var _row = [];

    for (var i = 1; i < rows.length; i++) {
      var _r = rows[i].split(",");

      if (_r.length !== 5) {
        alert("ข้อมูลไฟล์ CSV ผิด");
        return;
      }

      _row.push({
        weekday: _r[0].replace(/(?:\\[rn])+/g, ""),
        timestart: `${_r[1].replace(/(?:\\[rn])+/g, "")}:00`,
        timestop: `${_r[2].replace(/(?:\\[rn])+/g, "")}:00`,
        consultid: _r[3].replace(/(?:\\[rn])+/g, ""),
        campaignid: _r[4].replace(/(?:\\[rn])+/g, ""),
      });
    }

    return _row;
  }

  csvDownload = (event) => {
    event.preventDefault();

    if (!this.state.list.length) {
      UIkit.notification({
        message: "ไม่พบข้อมูลสำหรับดาวน์โหลด",
        status: "warning",
      });

      return;
    }

    const normalizeTime = (value) => {
      if (!value) {
        return "00:00";
      }

      var parts = value.split(":");
      return `${parts[0] || "00"}:${parts[1] || "00"}`;
    };

    const header = [
      "weekday",
      "timestart",
      "timestop",
      "consultid",
      "campaignid",
    ].join(",");

    const rows = this.state.list.map((list) => {
      return [
        list.weekday || "",
        normalizeTime(list.timestart),
        normalizeTime(list.timestop),
        list.consultid || "",
        list.campaignid || "",
      ].join(",");
    });

    const csvContent = [header, ...rows].join("\n");
    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const filename = `inspection-schedule-${new Date()
      .toISOString()
      .slice(0, 10)}.csv`;
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", filename);
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  csvUpload = (event) => {
    var reader = new FileReader();
    reader.readAsText($("#file-csv-upload")[0].files[0]);
    reader.onload = () => {
      var _text = reader.result;

      var _row = this.csvJSON(_text);

      if (_row.length > 0) {
        this.consultInspectionSave(_row);
      } else {
        UIkit.notification({
          message: "ไม่พบข้อมูลในไฟล์",
          status: "danger",
        });
      }
    };
  };

  handlePageClick = (page) => {
    this.setState({ pageNow: page.selected + 1 }, () =>
      this.consultInspectionListGet(),
    );
  };

  weekSelectRender = (option = {}) => {
    var weeks = [1, 2, 3, 4, 5];

    var _id = `${option.id ? `_${option.id}` : ""}`;

    return (
      <div className="uk-margin-top-small">
        {option.read_only === true ? (
          <span>
            W :{" "}
            {weeks.map((w) => {
              return option.list[`week${w}`] == 1 ? w : null;
            })}
          </span>
        ) : (
          weeks.map((w) => {
            return (
              <label className="uk-inline-block uk-margin-right">
                <input
                  type="checkbox"
                  className="uk-checkbox"
                  value="1"
                  checked={this.state[`week${w}${_id}`] == 1}
                  onChange={(e) => {
                    this.setState({
                      [`week${w}${_id}`]:
                        this.state[`week${w}${_id}`] == 1 ? 0 : 1,
                    });
                  }}
                />{" "}
                Week {w}
              </label>
            );
          })
        )}
      </div>
    );
  };

  paginateRender = () => {
    return (
      <div className="uk-text-right">
        <ReactPaginate
          className={"uk-padding-remove"}
          previousLabel={"previous"}
          nextLabel={"next"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={this.state.pageAmount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={this.handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
        />
      </div>
    );
  };

  render() {
    return (
      <div className={this.props.paddingRemove === true ? "" : "uk-padding"}>
        <div
          className={
            "uk-card uk-card-default uk-padding-small" +
            (this.props.paddingRemove === true ? "" : " uk-margin-top")
          }
        >
          <div className="d-card-header">
            <div className="d-card-header-left">ตารางออกตรวจแพทย์</div>
            <div className="d-card-header-right">
              <button
                className="uk-button uk-margin-right d-text-white uk-button-secondary"
                onClick={this.csvDownload}
              >
                <span
                  uk-icon="cloud-download"
                  className="uk-margin-small-right"
                ></span>
                Download CSV
              </button>
              <label className="uk-button uk-margin-right d-text-white">
                <input
                  type="file"
                  accept=".csv"
                  id="file-csv-upload"
                  onChange={this.csvUpload}
                  hidden
                />
                <span
                  uk-icon="cloud-upload"
                  className="uk-margin-small-right"
                ></span>
                Upload CSV
              </label>
              <button className="uk-button uk-button-primary">เพิ่ม</button>
            </div>
          </div>
          <div className="d-border uk-padding-small">
            <h4 className="uk-text-bold">เพิ่มข้อมูล</h4>
            <hr />
            <form onSubmit={this.consultInspectionAdd}>
              <div className="uk-grid">
                <div className="uk-width-1-1 uk-width-1-6@m">
                  <label>แพทย์</label>
                  <Autocomplete
                    wrapperStyle={{ width: "100%" }}
                    renderInput={(props) => {
                      return (
                        <input
                          {...props}
                          className="uk-input"
                          placeholder={"ชื่อแพทย์"}
                          value={this.state.consultName}
                          onChange={(e) => {
                            var _u = { consultName: e.target.value };

                            if (!e.target.value) {
                              _u.consultId = "";
                            }

                            this.setState(_u);
                          }}
                        />
                      );
                    }}
                    menuStyle={{
                      fontSize: "18px",
                    }}
                    onSelect={(value, data) => {
                      this.setState({
                        consultId: value,
                        consultName: `${data.nameprefix} ${data.name} ${data.lastname}`,
                      });
                    }}
                    getItemValue={(item) => item.id}
                    items={this.state.consultList.filter(
                      (d) =>
                        d.name.includes(this.state.consultName) ||
                        d.lastname.includes(this.state.consultName),
                    )}
                    onChange={(e) => (this.state.consultName = e.target.value)}
                    renderItem={(item, isHighlighted) => (
                      <div
                        key={item.id}
                        style={{
                          padding: "5px 10px",
                          background: isHighlighted ? "lightgray" : "white",
                          border: "1px solid #CCC",
                        }}
                      >
                        {item.nameprefix} {item.name} {item.lastname} (UID:{" "}
                        {item.id})
                      </div>
                    )}
                  />
                </div>
                <div className="uk-width-1-1 uk-width-1-6@m">
                  <label>แคมเปญ</label>
                  {this.campaignSelectRender()}
                </div>
                <div className="uk-width-1-1 uk-width-1-6@m">
                  <label>วัน</label>
                  {this.daySelectRender()}
                  {this.weekSelectRender()}
                </div>
                <div className="uk-width-1-1 uk-width-1-6@m">
                  <label>เวลาเริ่ม</label>
                  {this.timeSelectRender("start")}
                </div>
                <div className="uk-width-1-1 uk-width-1-6@m">
                  <label>เวลาสิ้นสุด</label>
                  {this.timeSelectRender("stop")}
                </div>
                <div className="uk-width-1-1 uk-width-1-6@m">
                  <label>ประเภท</label>
                  {this.appointmentTypeSelectRender()}
                </div>
              </div>
              <div className="uk-text-right uk-margin-top">
                <button className="uk-button uk-button-primary">
                  เพิ่มข้อมูล
                </button>
              </div>
            </form>
          </div>
          <div className="uk-grid uk-grid-small uk-margin-top">
            <div>
              <input className="uk-input" type="text" placeholder="ค้นหาชื่อ" />
            </div>
            <div>{this.appointmentTypeFilterSelectRender()}</div>
            <div>
              <button className="uk-button uk-button-primary">ค้นหา</button>
            </div>
          </div>
          <div className="uk-margin-top">{this.tableRender()}</div>
          <div>{this.paginateRender()}</div>
        </div>
      </div>
    );
  }
}
